// CacheKey b6e14de280972df2461f4528aaa8e2bf
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  en: {
    data_view: {
      default_name: {
        archived_audio_instructions_search: "Archived Care Recordings Search",
        audio_instructions_search: "Care Recordings Search",
        comments: "Care Notes",
        location_search: "Locations Search",
        patients_issues: "Open Cases",
        patients_search: "Patients Search",
        staff_members_issues: "Open Internal Cases",
        survey_interactions: "Kiosk Interactions",
        survey_issues: "Open Kiosk Cases",
        tasks_search: "Tasks Export",
        workflows: "Workflows"
      },
      alerts: {
        tagged_title: "<b>Alert:</b> %{name} has been tagged as %{tag}."
      },
      non_paginated_view_disclaimer: "The displayed items, size, and pages might not represent the actual data. We will never add pagination support to this page. It's only provided as a way to customize search filters using the UI, with the goal of running exports.",
      headers: {
        defaults: {
          answer: {
            ai_enhanced: "Conversational AI Question?",
            conversational_ai_response: "Patient Response (Conversational AI)"
          },
          audio_instruction: {
            _type: "Care Recording Type",
            created_at: "Recorded At",
            type: "Care Recording Type",
            user_name: "Recorded By"
          },
          author_department: {
            facility: "Author Department Facility",
            group: "Author Department Group",
            location: "Author Department Location",
            name: "Author Department Name",
            outreach_eligible: "Author Department Outreach Eligible?",
            phone: "Author Department Phone",
            phonetic_spelling: "Author Department Phonetic Spelling",
            reference_id: "Author Department Reference ID",
            roundable: "Author Department Roundable?",
            test_department: "Test Author Department"
          },
          author_staff_member: {
            email: "Author Email",
            employee_id: "Author Employee ID",
            first_name: "Author First Name",
            last_name: "Author Last Name",
            name: "Author Name",
            title: "Author Title"
          },
          archived_audio_instruction: {
            _type: "Care Recording Type",
            created_at: "Recorded At",
            type: "Care Recording Type",
            user_name: "Recorded By"
          },
          call: {
            patient_name: "Patient",
            phone: "Phone",
            action_name: "Outreach Action",
            program_name: "Outreach Program",
            scheduled_at: "Call Date"
          },
          call_attempt: {
            status: "Status/Who Answered",
            first_attempt_date: "First Attempt",
            launch_status: "Launch Restriction",
            number: "Outreach Attempt Number"
          },
          call_center: {
            transfer_limit: "Voice Transfer Limit"
          },
          care_gram: {
            recipients_employee_ids: "Recipient(s) Employee ID"
          },
          care_form: {
            name: "Form",
            user_name: "User"
          },
          captain: {
            name: "Captain",
            email: "Captain Email"
          },
          care_provider: {
            name: "Care Provider"
          },
          created_by: {
            name: "Created By"
          },
          comment: {
            author_name: "Author",
            created_at: "Date",
            message: "Message",
            related_encounter_id: "Encounter ID"
          },
          connection: {
            ip: "IP",
            created_at: "Created",
            updated_at: "Updated",
            speed: "msg/min",
            care_providers: "Care Provider"
          },
          department: {
            name: "Department Name"
          },
          echo: {
            discharge_instruction: "Discharge Instruction",
            audio_discharge_instruction: "Discharge Instruction",
            follow_up_info: "Follow Up Info",
            medication_info: "Medication Info",
            personal_message: "Personal Message",
            physician_message: "Physician Message"
          },
          encounter: {
            id: "Encounter _id",
            admit_source: "Admit Source",
            almost_prime_eligible: "Almost PRIME Eligible",
            appointment_location_resource: "Appointment Location",
            appointment_person_resource: "Appointment Person",
            arrival_date: "Arrival Date",
            attending_id: "Attending Code",
            attending_physician: "Attending Physician",
            care_gaps: "Care Gaps",
            created_at: "Encounter Created Date",
            currently_admitted: "Currently Admitted",
            department_reference_id: "Department Reference ID",
            department_short_title: "Department Short Name",
            discharge_date: "Discharge Date",
            discharge_disposition: "Discharge Disposition",
            encounter_id: "Encounter ID",
            episode_id: "Episode ID",
            episode_status: "Episode Status",
            expected_arrival_date: "Expected Arrival Date",
            expected_discharge_date: "Expected Discharge Date",
            facility_mrn: "Facility MRN",
            has_ami: "Has AMI",
            has_central_line: "Has Central Line",
            has_chf: "Has CHF",
            has_copd_asthma: "Has COPD",
            has_pneumo: "Has Pneumonia",
            has_sepsis: "Has Sepsis",
            has_stroke: "Has Stroke",
            mrn: "MRN",
            payor_status: "Payor Status",
            pending_transfer: "Pending Transfer",
            prime_population: "PRIME Population",
            provider_patient_id: "MRN",
            room: "Room",
            visit_provider_reference_id: "Visit Provider Reference ID",
            visit_type_name: "Visit Type",
            visit_type_reference_id: "Visit Type Reference ID"
          },
          enrollment: {
            active: "Active",
            member_id: "Member ID",
            npi: "NPI",
            payer_pcp_first_name: "Payer PCP First Name",
            payer_pcp_last_name: "Payer PCP Last Name",
            pcp_id: "PCP ID",
            pcp_phone_number: "PCP Phone Number",
            subscriber_id: "Subscriber ID",
            workflows: "Workflows"
          },
          enrollment_report: {
            updated_at: "Last Updated At"
          },
          group: {
            name: "Group"
          },
          import: {
            mrn: "MRN",
            sending_facility: "HL7 Name",
            almost_prime_eligible: "Almost PRIME Eligible",
            prime_population: "PRIME Population",
            file: "Actions"
          },
          interaction: {
            alert_names: "Issue Alerts",
            author_email: "Interaction Created By Email",
            author_name: "Interaction Created By",
            consent_updated_at: "Verbal Consent Updated At",
            consent_updated_by: "Verbal Consent Updated By",
            created_at: "Interaction Created At",
            finished_at: "Interaction End Time",
            from_inbound_call: "Inbound",
            id: "Interaction ID",
            name: "Program",
            priority_score_at_round: "Priority Score At Round",
            outreach_action_name: "Script Name",
            repeated_count: "Repeat Count",
            started_at: "Interaction Start Time",
            type: "Interaction Type",
            unit_name: "Unit",
            voice_channel: "Outreach Channel"
          },
          medical_conversation: {
            ambient_listening: "Ambient Listening",
            audio_link: "Recording"
          },
          issue: {
            created_at: "Issue Created At",
            escalated_to: "Escalated To",
            follow_up_needed_from: "Follow Up Needed From",
            id: "Issue ID",
            program_name: "Program",
            related_encounter_id: "Encounter ID",
            short_name: "Issue",
            status: "Status",
            time_open: "Time Open",
            type: "Issue Type",
            updated_at: "Last Updated"
          },
          issue_field_option: {
            answered_by: "Option Selected By",
            field_name: "Issue Field",
            id: "Option ID",
            updated_at: "Option Last Updated",
            value: "Option"
          },
          issue_alert: {
            link: "Name",
            rounding_model: "Alert For"
          },
          key_metric_source: {
            FitbitAccount: "Fitbit",
            JawboneAccount: "Jawbone",
            IhealthAccount: "iHealth"
          },
          location: {
            "shown_in_orchid?": "Available for Rounding"
          },
          observation: {
            started_at: "Date"
          },
          outreach_action: {
            name: "Outreach Action Name",
            expiration_shift: "Inbound Expiration (days)",
            inbound_start_question_index: "Call-in Start Question"
          },
          outreach_program: {
            criteria: "Activation Criteria",
            custom_call_hours: "Call Hours",
            inbound_intro_message: "Inbound Intro Message",
            inbound_test_outreach_action_id: "Inbound Test Outreach Action",
            inbound_mismatch_audio_message: "Inbound Mismatch Audio",
            name: "Follow-Up Program",
            outreach_use_case: "Configuration Type",
            phone: "Phone Number",
            prefix: "Phone Prefix"
          },
          patient: {
            aco_mssp_indicator: "ACO MSSP Indicator",
            age: "Age",
            caregiver_address: "Contact Address",
            caregiver_email: "Contact Email",
            caregiver_name: "Contact Name",
            caregiver_phone: "Contact Phone",
            caregiver_relationship: "Contact Relationship",
            last_used_phone: "Last Used Phone",
            name: "Name",
            id: "Patient ID",
            inverted_name: "Last Name, First Name",
            date_of_birth: "Date of Birth",
            date_of_death: "Date of Death",
            declined_to_record: "Declined to Record",
            gender: "Gender",
            phone: "Phone",
            primary_language: "Primary Language",
            preferred_outreach_language: "Preferred Outreach Language",
            dnr: "DNR",
            polst: "POLST",
            zip: "Zip Code"
          },
          shift_department: {
            facility: "Shift Department Facility",
            group: "Shift Department Group",
            location: "Shift Department Location",
            name: "Shift Department Name",
            outreach_eligible: "Shift Department Outreach Eligible?",
            phone: "Shift Department Phone",
            phonetic_spelling: "Shift Department Phonetic Spelling",
            reference_id: "Shift Department Reference ID",
            roundable: "Shift Department Roundable?",
            test_department: "Test Shift Department"
          },
          staff_member: {
            employee_id: "Employee ID",
            show_in_orchid: "Available for Rounding",
            inverted_name: "Last Name, First Middle"
          },
          unit: {
            name: "Unit",
            group: "Group",
            facility: "Facility",
            facility_short_title: "Facility Short Title",
            short_title: "Unit Short Title"
          },
          user: {
            active: "Active?",
            banned: "Disabled?",
            banned_by: "Disabled By",
            ios_version_number: "iOS Version",
            last_device: "Mobile Device",
            last_os: "Mobile OS",
            last_sign_in_at: "Previous Login",
            orchid_settings_outreach_program: "Rounding Settings Outreach Program",
            orchid_settings_selected_facilities: "Rounding Settings Selected Facilities",
            orchid_settings_selected_units: "Rounding Settings Selected Units",
            orchid_version_number: "CipherRounds Version",
            password_changed_at: "Last Password Reset",
            name: "User",
            sso_enabled: "SSO?",
            employer_id: "Employer ID"
          },
          workflow: {
            name: "Workflow"
          }
        },
        care_management_enrollments_search_view: {
          patient: {
            name: "Patient"
          }
        },
        care_grams_view: {
          staff_member: {
            name: "Staff Member Name"
          },
          location: {
            name: "Location Name"
          },
          patient: {
            name: "Patient Name"
          }
        },
        completed_calls_view: {
          outreach_action: {
            name: "Action"
          }
        },
        current_calls_view: {
          outreach_action: {
            name: "Action"
          }
        },
        diagnoses_view: {
          diagnosis: {
            name: "Name",
            icd_code: "ICD Code",
            icd_code_version: "ICD Code Version"
          },
          patient: {
            name: "Patient"
          }
        },
        goals_view: {
          goal: {
            name: "Goal"
          },
          patient: {
            name: "Patient"
          }
        },
        issue_events_view: {
          user: {
            name: "User Name"
          },
          issue_event: {
            issue_id: "Issue ID",
            issue_subpanel_id: "Subpanel ID",
            issue_subpanel_name: "Subpanel Name",
            response_id: "Response ID"
          }
        },
        locations_interactions_view: {
          interaction: {
            name: "Script"
          },
          location: {
            name: "Location"
          },
          location_group: {
            name: "Group"
          }
        },
        locations_issues_view: {
          location: {
            name: "Location"
          },
          location_group: {
            name: "Group"
          }
        },
        location_search_view: {
          location_group: {
            name: "Group"
          }
        },
        medications_view: {
          medication: {
            name: "Medication"
          },
          patient: {
            name: "Patient"
          }
        },
        observations_search_view: {
          patient: {
            name: "Patient"
          }
        },
        observation_results_search_view: {
          patient: {
            name: "Patient"
          },
          observation: {
            name: "Observation"
          }
        },
        patients_interactions_view: {
          department: {
            facility: "Department Facility"
          },
          encounter: {
            updated_at: "Encounter Updated At"
          },
          interaction: {
            call_attempt_status: "Interaction Status",
            name: "Program or Script",
            priority_score_at_round: "Priority Score At Round"
          },
          unit: {
            facility: "Unit Facility"
          }
        },
        patient_referrals_view: {
          referral: {
            referral_id: "Referral ID"
          }
        },
        referrals_search_view: {
          referral: {
            referral_id: "Referral ID"
          }
        },
        sso_connection: {
          care_provider_names: "Care Providers"
        },
        staff_rewards_view: {
          author: {
            name: "Author Name",
            email: "Author Email"
          },
          patient: {
            name: "Patient"
          },
          staff_member: {
            name: "Staff Member Name"
          }
        },
        staff_members_interactions_view: {
          interaction: {
            name: "Script"
          },
          staff_member: {
            name: "Staff Member Name"
          }
        },
        survey_interactions_view: {
          interaction: {
            name: "Survey"
          },
          survey_location: {
            name: "Location"
          }
        },
        upcoming_calls_view: {
          outreach_action: {
            name: "Action"
          }
        },
        workflows_view: {
          patient: {
            name: "Patient"
          }
        }
      }
    }
  }
}

